import tableData from "./data";
import Table from "./components/Table";

const UserReport = () => {
  return (
    <div className="mt-3 h-full w-full">
      {/* Coming Soon Banner */}
      <div className="mb-4 px-4 py-3 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-xl">
        <div className="flex items-center gap-2">
          <span className="text-[10px] px-1.5 py-0.5 rounded bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-400 font-medium">
            Coming Soon
          </span>
          <p className="text-sm text-yellow-700 dark:text-yellow-400">
            This feature is currently under development and will be available soon.
          </p>
        </div>
      </div>
      <Table tableData={tableData} />
    </div>
  );
};

export default UserReport;
